module.exports = __webpack_public_path__ + "assets/images/scrolly-test/1-desktop.jpg?v=711c7d0a";